import { useContext, useEffect } from "react";
import { AuthContext, AuthContextType } from "../context";
import { Navigate } from "react-router-dom";
import { useRefreshToken } from "@/features/auth-view/api";
import { Loader2 } from "lucide-react";

const RouteProtection = ({ children }: { children: React.ReactNode }) => {

  const { username, token } = useContext<AuthContextType>(AuthContext)

  const { refreshAccessToken, isError, isIdle, isSuccess, isLoading } = useRefreshToken()

  useEffect(() => {
    if (!token || !username) {
      refreshAccessToken();
    }
  }, [token, username]);

  // If we have valid credentials, render children
  if (token && username) {
    return <>{children}</>;
  }

  // Show loading while refreshing
  if (isLoading) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        <div className="flex flex-col items-center gap-2">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // If refresh failed or we're still missing credentials after refresh
  if (isError || (isSuccess && (!token || !username))) {
    return <Navigate to='/' replace />;
  }

  // Fallback for initial state
  if (isIdle && (!token || !username)) {
    return (

      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        <div className="flex flex-col items-center gap-2">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Personalizing Dashboard...</p>
        </div>
      </div>
    );
  }

  // This should not be reached but adding as a fallback
  return <div>Loading...</div>;
}

export default RouteProtection;
